import { render, staticRenderFns } from "./TituloPessoas.vue?vue&type=template&id=329f29c0&"
import script from "./TituloPessoas.vue?vue&type=script&lang=js&"
export * from "./TituloPessoas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports